import { defineNuxtPlugin } from '#imports'
import { useVehiclesStore } from '~/stores/vehicles'
import type { NuxtApp } from '#imports'
// import { devLog } from '~/utils/logger' // Commented out

export default defineNuxtPlugin(async (nuxtApp) => {
  // Ensure this runs only on the client
  if (process.client) {
    (nuxtApp as any).hooks.hook('app:mounted', async () => {
      // devLog('Initializing vehicles store globally on client mount...') // Commented out
      const vehiclesStore = useVehiclesStore()

      // The original logic here was commented out, so we mostly just ensure
      // the store instance is obtained within a safe context if it were to be used.
      // If there's specific logic to re-enable, it would go here.
      // console.log('[initVehiclesStore.client] app:mounted hook executed.');
    })
  }
}) 